import React from 'react';
import { DRAFT_TO_DOC_TYPE_WITH_LISTS } from 'wix-rich-content-common';

const DEFAULT_PALETTE = Object.freeze([
  "#ff0000",
  "#ffffff",
  "#303030",
  "#3a54b4",
  "#bfad80",
  "#dddddd"
]);
const extractPalette = (colorScheme) => {
  if (!colorScheme) {
    return DEFAULT_PALETTE;
  }
  return Object.values(colorScheme).sort((entry1, entry2) => entry1.index > entry2.index ? 1 : -1).map((entry) => entry.color);
};
const getBlockDocumentStyle = (editorCommands) => {
  const blockType = editorCommands.getAnchorBlockType();
  const documentStyle = editorCommands.getDocumentStyle();
  return documentStyle == null ? void 0 : documentStyle[DRAFT_TO_DOC_TYPE_WITH_LISTS[blockType]];
};
const colorPicker = ({ isMobile, header }) => {
  return ({
    renderPalette,
    renderUserColors,
    renderAddColorButton,
    renderResetColorButton,
    mergedStyles
  }) => /* @__PURE__ */ React.createElement(React.Fragment, null, isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_header }, header), /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_separator })), /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_palette }, /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_buttons_container }, renderPalette(), renderUserColors(), isMobile && renderAddColorButton()), !isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("hr", { className: mergedStyles.colorPicker_separator }), /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_bottom_container }, renderResetColorButton(), renderAddColorButton()))));
};

export { colorPicker, extractPalette, getBlockDocumentStyle };
//# sourceMappingURL=TextColorPicker.js.map
